import { createBrowserRouter, Navigate } from 'react-router-dom'

import { Home } from '@/pages'

export const router = createBrowserRouter([
	{
		path: '/',
		errorElement: <Navigate to="/" replace={true} />,
		element: <Home />
	}
])
